import { css } from 'react-emotion'

const styles = {
  component: css({
    padding: '0 10px 0 10px',
    lineHeight: '35px',
    color: '#919191'
  }),
  current: css({
    marginRight: '5px',
    fontSize: '12px',
    color: '#919191'
  }),
  duration: css({
    marginLeft: '5px',
    color: '#919191',
    fontSize: '12px'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Time/TimeStyles.js